import { render } from "./JoinTypeSelectionPopup.vue?vue&type=template&id=3fbfde7c&scoped=true&ts=true"
import script from "./JoinTypeSelectionPopup.vue?vue&type=script&lang=ts"
export * from "./JoinTypeSelectionPopup.vue?vue&type=script&lang=ts"

import "./JoinTypeSelectionPopup.vue?vue&type=style&index=0&id=3fbfde7c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbfde7c"]])

export default __exports__